import Vue from "vue";
import { formatNumber, changeSeparator } from "@/helpers";
// import dayjs from "dayjs";

Vue.filter("CLP", value => {
  return "$" + formatNumber(value);
});

Vue.filter("UF", value => {
  return changeSeparator((value)) + " UF";
});

Vue.filter("USD", value => {
  return changeSeparator((value)) + " USD";
});

// Vue.filter("date", value => {
//   return dayjs(value).format("YYYY-MM-DD");
// });
